import React from "react";
import { UserOutlined, MailOutlined } from "@ant-design/icons";
import { Spin, message, Space, Checkbox, Form } from "antd";
import ProForm, { ProFormCaptcha, ProFormText } from "@ant-design/pro-form";
import logo_2 from '../img/logo_2.png'
let {LOGINURL} = window.config
const Session = () => {

    const handleGetCaptcha = async (phone) => {
        const url = `${LOGINURL}/v3/SMS/checkCode?action=1&lang=7&mobile=${phone}&teleCode=%2B86`
        const res = await fetch(url);
        const json = await res.json();
        if (json.code === 100) {
            message.success(`手机号 ${phone} 验证码发送成功!`);
        } else {
            throw new Error("获取验证码错误");
        }
    };

    const handleFormFinish = async ({ phone, captcha }) => {
        const url1 = `${LOGINURL}/v1/token/checkCode?code=${captcha}&lang=7&mobile=${phone}&teleCode=%2B86`
        const res1 = await fetch(url1);
        const resJson1 = await res1.json();
        if (resJson1.code !== 100) {
            message.error(`验证码错误，登录失败!`);
            return false;
        }
        sessionStorage.setItem('mobile', phone);
        window.location.replace("/home");
        // TODO - 当前登录接口不能使用，只要验证验证码正确，即可。
        // const url2 = 'http://106.38.108.70:48080/api/v6/session?lang=7';
        // const loginParams = {
        //     teleCode: '+86',
        //     mobile: phone,
        //     code: captcha,
        // }
        // const res2 = await fetch(url2, {method: 'POST', body: JSON.stringify(loginParams)});
        // const resJson2 = await res2.json();
        // if (resJson2.code === 100) {
        //     message.success(`登录成功!`);
        //     sessionStorage.setItem('mobile', resJson2.data.mobile);
        // } else {
        //     message.error(`登录失败!`);
        // }
    }

    const isLoading = false;
    return (
        <Spin spinning={isLoading} size="large">
            <div className="login_container">
                <ProForm
                    isKeyPressSubmit
                    onFinish={handleFormFinish}
                    submitter={{
                        searchConfig: {
                            submitText: "登录/注册",
                        },
                        render: (_, dom) => dom.pop(),
                        submitButtonProps: {
                            size: 'large',
                            style: {
                                width: '100%',
                            },
                        },
                    }}
                >
                    <div className="top">
                        <Space size={"large"}>
                            <img src={logo_2} alt="logo_icon" />
                            <div className="title">润脉科技</div>
                        </Space>
                    </div>
                    <ProFormText
                        name="phone"
                        placeholder="请输入手机号"
                        rules={[
                            { required: true, message: "请输入手机号", },
                        ]}
                        fieldProps={{
                            size: 'large',
                            prefix: <UserOutlined />,
                        }}
                    />
                    <ProFormCaptcha
                        fieldProps={{
                            size: 'large',
                            prefix: <MailOutlined />,
                        }}
                        captchaProps={{
                            size: 'large',
                        }}
                        // 手机号的 name，onGetCaptcha 会注入这个值
                        phoneName="phone"
                        name="captcha"
                        rules={[
                            {
                                required: true,
                                message: '请输入验证码',
                            },
                        ]}
                        placeholder="请输入验证码"
                        // 如果需要失败可以 throw 一个错误出来，onGetCaptcha 会自动停止
                        // throw new Error("获取验证码错误")
                        onGetCaptcha={handleGetCaptcha}
                    />
                    <Form.Item
                        name="agreement"
                        valuePropName="checked"
                        rules={[
                            {
                                validator: (_, value) =>
                                    value ? Promise.resolve() : Promise.reject(new Error('需要阅读并同意相关协议')),
                            },
                        ]}
                    >
                        <Checkbox>
                            已阅读和同意润脉科技<a href="/service_protocol.html">用户协议</a>和<a href="/privacy_protocol.html">隐私政策条款</a>
                        </Checkbox>
                    </Form.Item>
                </ProForm>
            </div>
        </Spin>
    );
};

export default Session;